import reducer from "./reducer";
export { default as Fiscalization } from "./components/index";
export { default as fiscalizationReducerName } from "./constants";
export default reducer;

